export default __webpack_public_path__ + "static/stacked-area-a359dc42da744005ede2ece80d76bc9d.png";